// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"2809cad7","123":"4b61d90a","427":"f3b3ce6f","462":"298fc63e","624":"64170070","785":"238741fe","791":"711eef92","831":"434c451a","914":"ec3cb7ee","958":"2c662e32"}[chunkId] + ".chunk.js";
};